export const APPLICATION_BOOTSTRAPPED = '';
export const AUTHENTICATION_SUCCESS = 'AUTHENTICATION_SUCCESS';
export const AUTHENTICATION_FAIL = 'AUTHENTICATION_FAIL';
export const SEARCH_INITIATED = 'SEARCH_INITIATED';
export const SEARCH_TERMINATED = 'SEARCH_TERMINATED';
export const LOGIN_ATTEMPTED = 'LOGIN_ATTEMPTED';
